import {
  CREATE_PLC_SAFETY_EVENT,
  CREATE_PLC_SAFETY_EVENT_SUCCESSFUL,
  CREATE_PLC_SAFETY_EVENT_FAILED,
} from './actionTypes';

const initialState = {
  createPlcSafetyEventError: null,
  messagePlcSafetyEvent: null,
  loadingCreatePlcSafetyEvent: false,
};

const createEvent = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_PLC_SAFETY_EVENT:
      state = { ...state, loadingCreatePlcSafetyEvent: true, createPlcSafetyEventError: null };
      break;
    case CREATE_PLC_SAFETY_EVENT_SUCCESSFUL:
      state = {
        ...state,
        loadingCreatePlcSafetyEvent: false,
        messagePlcSafetyEvent: action.payload,
        createPlcSafetyEventError: null,
      };
      break;
    case CREATE_PLC_SAFETY_EVENT_FAILED:
      state = {
        ...state,
        messagePlcSafetyEvent: null,
        loadingCreatePlcSafetyEvent: false,
        createPlcSafetyEventError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default createEvent;
